import { PropsWithChildren } from 'react';

import { Inline, u } from '@ui';

import * as css from './PlaybackControls.css';
import { PlaybackPlayControls } from './PlaybackPlayControls';
import { PlaybackPositionControls } from './PlaybackPositionControls';

type PlaybackControlsProps = PropsWithChildren<{
    syncOnly?: boolean;
    freezePosition?: string | null;
    onFreezePositionChange?: (position: string | null) => void;
}>;

export const PlaybackControls = ({
    syncOnly,
    freezePosition,
    onFreezePositionChange,
    children,
}: PlaybackControlsProps) => (
    <Inline
        flexWrap="wrap-reverse"
        alignItems="center"
        justifyContent="space-between"
        paddingBlock={u(2.5)}
        className={css.controlsWrapper}
    >
        <PlaybackPlayControls />
        {children}
        <PlaybackPositionControls
            syncOnly={syncOnly}
            freezePosition={freezePosition}
            onFreezePositionChange={onFreezePositionChange}
        />
    </Inline>
);
